import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { CampaignsService } from '../CampaignsService';
import { toast } from 'react-toastify';
import { UPDATED_CAMPAIGN } from '../../../enum/Messages';
import { getCorrectEnums } from '../../../utils/Functions';
import { Campaign } from '../../../model/campaign/Campaign';
import { calculateFee } from '../../../utils/helpers/FeeCaluculation';
import { ErrorToast } from '../../../utils/toasters';
import CardLayout from '../../../shared/components/CardLayout';

export function CampaignUpdateForm() {
    const navigate = useNavigate();
    const { state }: any = useLocation();
    const { id } = useParams<any>();

    const [campaignData, setCampaignData] = useState<Partial<Campaign>>({
        approvalStatus: state?.approvalStatus,
        status: state?.status,
        feePercentage: +state?.feePercentage,
        isTransparentPricing: state?.isTransparentPricing,
        isCharity: state?.isCharity,
        isPicked: state?.isPicked,
        paymentTerms: state?.paymentTerms,
        paymentTermsCustom: state?.paymentTermsCustom,
    });
    const { campaignStatus, CampaignValidationStatusEnum, PaymentTermsEnum } = useSelector((state: any) => state.enums);

    function handleChange(evt: any) {
        const { name, value, checked } = evt.target;
        setCampaignData({
            ...campaignData,
            [name]: name === 'feePercentage' && (+value > 1 || +value < 0) ? 1 : value,
            isTransparentPricing: name === 'isTransparentPricing' ? checked : campaignData.isTransparentPricing,
            isCharity: name === 'isCharity' ? checked : campaignData.isCharity,
            isPicked: name === 'isPicked' ? checked : campaignData.isPicked,
        });
    }

    const editCampaign = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        CampaignsService.editCampaign(+id!, campaignData)
            .then(() => {
                toast(UPDATED_CAMPAIGN);
                navigate('/campaign/list');
            })
            .catch(err => ErrorToast(err));
    };

    return (
        <div>
            <div className="mb-3">
                <h3>
                    Edit campaign: ({state?.id}) {state?.title}
                </h3>
            </div>

            <CardLayout>
                <Form onSubmit={e => editCampaign(e)}>
                    <Row>
                        <Form.Group as={Col} className="col-3">
                            <Form.Label>Status</Form.Label>

                            <Form.Select value={campaignData?.status} name="status" onChange={handleChange}>
                                {/*<option value="">Campaign status</option>*/}
                                {campaignStatus.map((item: string) => (
                                    <option key={item} value={item}>
                                        {getCorrectEnums(item)}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Label>Approval status</Form.Label>
                            <Form.Select
                                value={campaignData?.approvalStatus}
                                name="approvalStatus"
                                onChange={handleChange}
                            >
                                {CampaignValidationStatusEnum?.map((item: string) => (
                                    <option key={item} value={item}>
                                        {getCorrectEnums(item)}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>{' '}
                        <Form.Group as={Col} className="col-3">
                            <Form.Label>Fee (0 - 1) Currently: {calculateFee(campaignData.feePercentage)}</Form.Label>
                            <Form.Control
                                type="number"
                                step="0.01"
                                min={0}
                                max={1}
                                name="feePercentage"
                                onChange={handleChange}
                                value={campaignData?.feePercentage ?? ''}
                            />
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Label>Payment terms</Form.Label>
                            <Form.Select
                                value={campaignData?.paymentTerms}
                                defaultValue={campaignData?.paymentTerms}
                                name="paymentTerms"
                                onChange={handleChange}
                            >
                                {PaymentTermsEnum?.map((item: string) => (
                                    <option key={item} value={item}>
                                        {getCorrectEnums(item)}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                        {campaignData?.paymentTerms === 'other' && (
                            <Form.Group as={Col} className="col-12 mb-4">
                                <Form.Label>Payment terms description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    maxLength={1000}
                                    placeholder="Payment terms custom"
                                    className="autocomplete-input mb-0"
                                    value={campaignData?.paymentTermsCustom}
                                    name="paymentTermsCustom"
                                    onChange={handleChange}
                                />
                                <Form.Text muted>
                                    {campaignData?.paymentTermsCustom?.length || 0}/1000 characters
                                </Form.Text>
                            </Form.Group>
                        )}
                        <Form.Group as={Col} className="col-auto">
                            <Form.Check
                                label="Transparent pricing"
                                name="isTransparentPricing"
                                defaultChecked={campaignData?.isTransparentPricing}
                                data-toggle="toggle"
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group as={Col} className="col-auto">
                            <Form.Check
                                label="Barter deal"
                                name="isCharity"
                                defaultChecked={campaignData?.isCharity}
                                data-toggle="toggle"
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group as={Col} className="col-auto">
                            <Form.Check
                                label="Picked"
                                name="isPicked"
                                defaultChecked={campaignData?.isPicked}
                                data-toggle="toggle"
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Row>
                    <div className="d-flex justify-content-end">
                        <Button size="lg" type="submit">
                            Save
                        </Button>
                    </div>
                </Form>
            </CardLayout>
        </div>
    );
}
